var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-remote-monitoring-questionnaires',{on:{"on-select-item":_vm.onSelectItemHandler,"on-go-to-add-page":_vm.goToAddHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }